import { SignInForm } from "Auth/Components/SignInForm";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { UnauthenticatedLayout } from "Shared/Layouts/UnauthenticatedLayout";

export const SignInPage = () => {
	const { t } = useResource();
	return (
		<UnauthenticatedLayout title={t(Resources.SignIn.Title)}>
			<SignInForm />
		</UnauthenticatedLayout>
	);
};
